import { render } from "./CreateGeofence.vue?vue&type=template&id=242353f6&scoped=true"
import script from "./CreateGeofence.vue?vue&type=script&lang=js"
export * from "./CreateGeofence.vue?vue&type=script&lang=js"

import "./CreateGeofence.vue?vue&type=style&index=0&id=242353f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242353f6"]])

export default __exports__